var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomButtonsIconNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.081 4.407V2.325c0-.26.28-.414.49-.27l4.956 3.287a.33.33 0 010 .54L9.57 9.17c-.21.144-.49-.01-.49-.27V6.815H5.973c-.536 0-.97.448-.97 1V13.7s-.13.3-.292.3H2.959a.295.295 0 01-.292-.3V7.213c0-1.55 1.219-2.806 2.722-2.806z"
  })));
}
export default SvgBottomButtonsIconNavigation;